import { Component, OnInit } from '@angular/core';
import { User } from '@data/schema/user-state';
import { UserStoreService } from '@gah-core/services/user-store.service';
import { FooterService } from '@shared/services/footer.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  public currentYear: number = new Date().getFullYear();
  privacyPolicyLinks: string[] = [];
  additionalDocumentsLinks: string[] = [];
  termsOfUserLinks: string[] = [];
  footerLinks: any;
  socialMediaLinks: any;
  currentTerritoryId: number = null;

  constructor(private footerService: FooterService, private userStoreService: UserStoreService) {}

  ngOnInit() {
    this.footerService.getFooterLinks();
    this.updateSocialMediaLinks();
  }
  showPrefDialog(event: any) {
    event.preventDefault();
    (window as any).OneTrust.ToggleInfoDisplay();
  }

  updateSocialMediaLinks() {
    // * Implemented this way to not make footer social media request if user state is not updated yet.
    this.userStoreService.userState$.subscribe((userState: User) => {
      if (!userState?.selectedTerritory?.territoryId) {
        this.socialMediaLinks = {};
        this.currentTerritoryId = null;
        return;
      }
      if (this.currentTerritoryId !== Number(userState?.selectedTerritory?.territoryId)) {
        this.currentTerritoryId = Number(userState?.selectedTerritory?.territoryId);
        this.footerService.getSocialMediaLinks().subscribe((data: any) => {
          this.socialMediaLinks = data;
        });
      }
    });
  }
}
